export default "__VITE_ASSET__DurmIANL__"